import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import TablaCallesDeCaladoView from '../../components/callesDeCalado/TablaCallesDeCaladoView'
import { obtenerDatosCallesDeCalado } from '../../actions'

function CallesDeCalado (props) {
  const { obtenerDatosCallesDeCalado } = props

  useEffect(() => {
    obtenerDatosCallesDeCalado()
  }, [obtenerDatosCallesDeCalado])

  return (
    <>
      <h2>Calles de calado</h2>
      <TablaCallesDeCaladoView />
    </>
  )
}

const mapActionsToProps = {
  obtenerDatosCallesDeCalado
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(CallesDeCalado)
